import React from 'react';
import Icon from '../IconBase/Icon';
import(`./styles/${window.__litium.themeName}.scss`);

const MessageBar = ({ cssClass, text, icon, type = '' }) => {
  if (text === undefined || text === '') {
    return null;
  }
  icon = icon ? icon : 'info';
  return (
    <div
      className={`message-bar-content-wrapper ${
        type ? 'message-bar-content-wrapper--' + type : ''
      } ${cssClass ? cssClass : ''}`}
    >
      <Icon
        iconCode={icon}
        iconClass={`message-bar__icon message-bar__${icon}-icon`}
      />
      <span className="message-bar__text">{text}</span>
    </div>
  );
};

export default MessageBar;
